import {putAdviserInCache} from 'hooks/advisers';
import {putAdviseSessionInCache} from 'hooks/adviseSessions';
import api from 'services/Api';

export function updateProfile(data) {
  return api.invoke('PATCH', '/core/v1/users/profile', data);
}

export async function fetchSelfInfo() {
  const response = await api.invoke(
    'GET',
    '/core/v1/users/selfInfo',
    undefined,
    {
      api: {
        emitNotification: true,
      },
    },
  );

  const {
    data: {
      myAdviser,
      comingUpOutgoingAdviseSession,
      comingUpIncomingAdviseSession,
    },
  } = response;

  if (myAdviser) {
    putAdviserInCache(myAdviser);
  }

  if (comingUpOutgoingAdviseSession) {
    putAdviseSessionInCache(comingUpOutgoingAdviseSession);
  }
  if (comingUpIncomingAdviseSession) {
    putAdviseSessionInCache(comingUpIncomingAdviseSession);
  }

  return response;
}

export async function fetchMyAdviserQrCode() {
  const {data} = await api.invoke(
    'GET',
    '/core/v1/users/selfInfo/myAdviserQrCode',
  );
  return data;
}

export async function fetchGenerateInviteLink() {
  const {data} = await api.invoke('GET', '/core/v1/users/shortLink');
  return data;
}


export function createAdviserReferralShortLink() {
  return api.invoke('POST', '/core/v1/users/shortLink');
}

export function addToFavorites(userId) {
  return api.invoke(
    'POST',
    '/core/v1/users/favorites',
    {userId},
    {
      api: {
        emitNotification: true,
      },
    },
  );
}

export function removeFromFavorites(userId) {
  return api.invoke('DELETE', `/core/v1/users/favorites/${userId}`, undefined, {
    api: {
      emitNotification: true,
    },
  });
}

export async function fetchUsersBulkInfo(ids) {
  const {data} = await api.invoke('Post', '/core/v1/users/bulkInfo/', {
    ids,
  });
  return data;
}

export async function fetchUserFavorites(offset, limit) {
  const {data} = await api.invoke('GET', '/core/v1/users/favorites', null, {
    params: {
      offset,
      limit,
    },
  });

  for (const adviser of data.advisers) {
    putAdviserInCache(adviser);
  }

  return data.advisers;
}

export function blockUser(userId) {
  return api.invoke(
    'POST',
    '/core/v1/users/blockedUsers',
    {userId},
    {
      api: {
        emitNotification: true,
      },
    },
  );
}

export function unblockUser(userId) {
  return api.invoke(
    'DELETE',
    `/core/v1/users/blockedUsers/${userId}`,
    undefined,
    {
      api: {
        emitNotification: true,
      },
    },
  );
}

export async function fetchBlockedUsers(offset, limit) {
  const {data} = await api.invoke('GET', '/core/v1/users/blockedUsers', null, {
    params: {
      offset,
      limit,
    },
  });
  return data.users;
}

export function deleteBlockedUsers(userId) {
  return api.invoke('DELETE', `/core/v1/users/blockedUsers/${userId}`);
}

export function createPartnerUrl(data) {
  return api.invoke('POST', '/core/v1/users/selfInfo/partnerUrl', data, {
    api: {
      emitNotification: true,
    },
  });
}
